/* 公共 FAQ（snippets/nx-qa.liquid）— 「更多」圆钮展开被折叠的问题
 * 手风琴本身是原生 <details>/<summary>，不依赖本脚本；这里只负责：
 * 1. 点击 [data-nx-qa-more] → 显示 [data-nx-qa-extra]、同步 aria-expanded、隐藏圆钮，焦点移到第一条新问题；
 * 2. 主题编辑器里选中被折叠的 FAQ block 时自动展开并打开该条。
 * 事件委托挂在 document 上，编辑器重渲染 section 后无需重新绑定。
 */
(() => {
  if (window.nxQaReady) return;
  window.nxQaReady = true;

  const revealExtra = (root, { moveFocus = false } = {}) => {
    const extra = root.querySelector('[data-nx-qa-extra]');
    const toggle = root.querySelector('[data-nx-qa-more]');
    const toggleWrap = root.querySelector('[data-nx-qa-more-wrap]');

    if (!extra || !extra.hidden) return;

    extra.hidden = false;
    toggle?.setAttribute('aria-expanded', 'true');
    toggleWrap && (toggleWrap.hidden = true);
    moveFocus && extra.querySelector('summary')?.focus();
  };

  const handleClick = (event) => {
    const toggle = event.target.closest?.('[data-nx-qa-more]');
    const root = toggle?.closest('[data-nx-qa]');
    root && revealExtra(root, { moveFocus: true });
  };

  const handleBlockSelect = (event) => {
    const item = event.target.closest?.('[data-nx-qa-item]');
    const root = item?.closest('[data-nx-qa]');
    if (!root) return;
    revealExtra(root);
    item.open = true;
  };

  document.addEventListener('click', handleClick);
  document.addEventListener('shopify:block:select', handleBlockSelect);
})();
